import React, { useState } from "react";

import { Notifications } from "@mui/icons-material";
import {
  Badge,
  IconButton,
  Popover,
  useMediaQuery,
  useTheme
} from "@mui/material";

import { useAuth } from "@/src/auth/hooks/useAuth";

import { useGetNotifications } from "../../../queries/notifications/notificationQueries";
import {
  notificationBadgeSx,
  notificationBellIconSx,
  notificationMenuButtonSx,
  notificationPopoverPaperSx
} from "./notificationMenu.styles";
import NotificationPanel from "./NotificationPanel";

const NotificationMenu = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const { isAuthenticated } = useAuth();

  const open = Boolean(anchorEl);

  const { data } = useGetNotifications(isAuthenticated);
  const notifications = data ?? [];

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const handleClose = () => {
    setAnchorEl(null);
  };

  const unreadNotifications = notifications.filter(({ isRead }) => !isRead);

  return (
    <>
      <IconButton
        sx={notificationMenuButtonSx(open)}
        onClick={(e) => {
          setAnchorEl(e.currentTarget);
        }}
      >
        <Badge
          variant="standard"
          color="secondary"
          badgeContent={unreadNotifications.length}
          sx={notificationBadgeSx}
        >
          <Notifications sx={notificationBellIconSx} />
        </Badge>
      </IconButton>
      <Popover
        anchorEl={anchorEl}
        open={open}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right"
        }}
        onClose={handleClose}
        slotProps={{ paper: { sx: notificationPopoverPaperSx } }}
      >
        <NotificationPanel
          isMobile={isMobile}
          notifications={notifications}
          handleCloseMenu={handleClose}
        />
      </Popover>
    </>
  );
};

export default NotificationMenu;
